export const defaultConfig: { gatewayGraphqlUrl: string } = {
	gatewayGraphqlUrl: '/gateway/api/graphql',
};
